module.exports = __webpack_public_path__ + "img/图片13.384ffc9d.png";